<template>
  <div>
    <start-date-form
      :has-vignette="hasVignette"
      class="question-box mb-5"
      @updateData="updateStartDate"
    />
    <contact-form
      class="question-box mb-5"
      @updateData="updateContactData"
    />
    <shipping-form
      class="question-box mb-5"
      @updateData="updateShippingData"
    />
    <transition-group
      enter-active-class="fadeIn"
      leave-active-class="fadeOutFast"
      mode="out-in"
    >
      <div v-if="completedSection" :key="'goNextRow'" class="d-flex justify-center">
        <v-btn
          color="#df0100"
          class="base-button"
          depressed
          tile
          dark
          large
          @click="$emit('nextStep', dataLayerEvent)"
        >
          Inainte
        </v-btn>
      </div>
    </transition-group>
  </div>
</template>

<script>
import StartDateForm from '@/components/rca/StartDateForm';
import ContactForm from '@/components/rca/ContactForm';
import ShippingForm from '@/components/rca/ShippingForm';
import { CONSTANTS } from '@/_utils/static-data';
export default {
  name: 'ConfirmationStep',
  components: {
    ShippingForm,
    ContactForm,
    StartDateForm
  },
  props: {
    hasVignette: Boolean,
    sectionType: {
      type: String,
      default: 'rca'
    }
  },
  data() {
    return {
      validStartDate: false,
      startDate: null,
      vignetteDate: null,
      contactInfo: [],
      validContactInfo: false,
      shippingInfo: [],
      validShippingInfo: false
    };
  },
  computed: {
    isGreenCard() {
      return this.sectionType === 'greenCard';
    },
    dataLayerEvent() {
      const shippingMode = this.shippingInfo?.[0]?.text;
      if (!shippingMode || (shippingMode !== 'delivery' && shippingMode !== 'self')) {
        return null;
      }
      return shippingMode !== 'delivery'
        ? this.isGreenCard ? CONSTANTS.greenCardEventConfirmationDelivery : CONSTANTS.rcaEventConfirmationDelivery
        : this.isGreenCard ? CONSTANTS.greenCardEventConfirmationPickUp : CONSTANTS.rcaEventConfirmationPickUp;
    },
    completedSection() {
      console.log('VALID START DATE: ', this.validStartDate);
      console.log('VALID CONTACT INFO: ', this.validContactInfo);
      console.log('VALID SHIPPING INFO: ', this.validShippingInfo);
      return this.validStartDate && this.validContactInfo && this.validShippingInfo;
    }
  },
  methods: {
    updateStartDate({ startDate, vignetteDate, isValid }) {
      console.log('dates', startDate, vignetteDate, isValid);
      this.startDate = startDate;
      this.vignetteDate = vignetteDate;
      this.validStartDate = isValid;
      this.$emit('updateStartDate', {
        startDate: this.startDate,
        vignetteDate: this.vignetteDate,
        isValid
      });
    },
    updateContactData({ data, isValid }) {
      if (!data) { return; }
      this.contactInfo = JSON.parse(JSON.stringify(data));
      this.validContactInfo = isValid;
      this.$emit('updateContactInfo', { data: this.contactInfo, isValid });
    },
    updateShippingData({ data, isValid }) {
      this.shippingInfo = data;
      this.validShippingInfo = isValid;
      this.$emit('updateShippingInfo', { data: this.shippingInfo, isValid });
    }
  }
};
</script>

<style scoped>
.question-box {
  width: 100%;
  background-color: #E7EFFD;
  padding: 8px;
  border-radius: 4px 4px 4px 4px;
}
</style>
